<template>
    <div class="tabs-center">
        <a-form
                :model="formInline"
                name="basic"
                autocomplete="off"
                @finish="handleSubmit"
                @error="handleError"
        >
            <div v-if="!openPwd">
                <h3>确认手机号</h3>
                <a-form-item
                        name="tel"
                        :validate-status="formErrors.telError ? 'error' : ''"
                        :help="formErrors.telError"
                        :rules="[{ required: true, message: '请输入常用手机号' }]"
                >
                    <a-input v-model:value="formInline.tel" placeholder="请输入常用手机号"/>
                </a-form-item>
                <a-form-item
                        name="code"
                        :validate-status="formErrors.codeError ? 'error' : ''"
                        :help="formErrors.codeError"
                        :rules="[{ required: !isDEV, message: '请输入手机验证码' }]"
                >
                    <a-input v-model:value="formInline.code" placeholder="请输入手机验证码" style="width: 50%"/>
                    <a-button style="float: right;width: 48%" @click="getCode" block :disabled="disabled">{{btnText}}</a-button>

                </a-form-item>
                <a-form-item v-if="unRegister">
                    <a-checkbox v-model:checked="formInline.resource">未注册手机号将自动注册</a-checkbox>
                </a-form-item>
                <div style="text-align: center; margin-bottom: 15px">
                    <a-button type="primary" @click="handleSubmitByCode">确认</a-button>
                </div>
            </div>
            <div v-else>
                <h3>修改登录密码</h3>
                <a-form-item
                        name="password"
                        :validate-status="formErrors.passwordError ? 'error' : ''"
                        :help="formErrors.passwordError"
                        :rules="[
                ({  }) => ({
                                  validator(_, value) {
                                    if(value){
                                      if(value.length < 6) return Promise.reject(new Error('密码至少6位'));
                                      if(!/[A-Z]/.test(value)) return Promise.reject(new Error('密码必须包含大写字母'));
                                      if(!/\d/.test(value)) return Promise.reject(new Error('密码必须包含数字'));
                                    }
                                  },
                                }),
                ]"
                >
                    <a-input-password v-model:value="formValues.password" placeholder="请输入密码"/>
                </a-form-item>
                <a-form-item
                        name="confirm"
                        :validate-status="formErrors.confirmError ? 'error' : ''"
                        :help="formErrors.confirmError"
                        :rules="[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两个密码不一致!'));
                                  },
                                }),
                                ]"
                >
                    <a-input-password v-model:value="formValues.confirm"  placeholder="请再次输入密码"/>
                </a-form-item>

                <div style="text-align: center; margin-bottom: 15px">
                    <a-button type="primary" @click="()=>handleSubmitByCode1(true)" block>确 定</a-button>
                </div>

            </div>

        </a-form>
    </div>
</template>

<script>
    import {
        login_success
    } from '@/utils/api';
    import {isDEV} from '@/utils/request';
    import {
        post_auth_token_password,
    } from "@/utils/paper.account";
    // import {token_key} from "@/utils/request";
    import {post_auth_code_password, put_auth_password_reset} from "../../utils/paper.account";
    const handleSuccess = (values)=>{
        login_success(values.account, values.password);
        window.location.reload();
    };
    const onFinish = (values) => {
        console.log('Success:', values);
        // if(isDEV){
        //     handleSuccess(values);
        //     return;
        // }
        let {account, password} = values;
        post_auth_token_password({account, password}, (res)=>{
            console.log('post_auth_token_password', res);
            const {status, message} = res;
            console.log(status, message);
            if (status === 1) {
                handleSuccess(values);
            }
        });
        // 发起请求
        // auth_request({
        //     url: '/confirm/', data: {account, password}, type: 'post',
        //     success: function (res) {
        //         // 页面跳转
        //         const {status, message} = res;
        //         console.log(status, message);
        //         if (status === 1) {
        //             handleSuccess(values);
        //         }
        //         else if (status === 901) jy_tip('密码超过五次不正确，账户已被锁定。请二十分钟后重试');
        //         else if (status === 10401) jy_tip(`密码第${message[message.length - 1]}次输入不正确。输入错误超过五次，将锁定账户，请谨慎`);
        //         else if (status === 10501) jy_tip(`账户${values.account}不存在, 请检查或注册`);
        //         else jy_tip(`登录失败, ${message}。请稍后重试或者联系管理员`);
        //         //this.context.router.push('/project/');
        //     }
        // });
    };
    export default {
        name: "ResetPassword",
        props: ['tel'],
        components: {
        },
        data() {
            return {
                isDEV,
                openPwd: false,
                formInline: {
                    account: '',
                    password: '',
                    tel: this.tel
                },
                business: '',
                unRegister: false,
                btnText: '获取验证码',
                disabled: false,
                formErrors: {
                    telError: ''
                },
                formValues: {},
                unbind: {}
            };
        },
        methods: {
            handleSubmit() {
                onFinish(this.formInline);
            },
            handleError(erros){
                console.log('errors', erros);
            },
            handleSubmitByCode() {
                this.openPwd = true;
            },
            handleSubmitByCode1() {
                let {tel, code} = this.formInline;
                let {password} = this.formValues;
                let rq = {tel, code};
                put_auth_password_reset({...rq, new_password: password}, (res)=>{
                    console.log('put_auth_password_reset res', res);
                    if(res?.status === 2) handleSuccess({account: localStorage.getItem('account'), password});
                    else if(res?.status === 10405) {
                        this.openPwd = false;
                        this.setError('code', '验证码已超时');
                    }
                    else if(res?.status === 10404 || res?.status === 10305) {
                        this.openPwd = false;
                        this.setError('code', '验证码不正确');
                    }
                    else this.setError('password', res?.message);
                    // handleSuccess(res?.data?.user_info || {});
                })
            },
            getCode(){
                let {tel} = this.formInline;
                if(!tel){
                    this.setError( 'tel', '请输入手机号');
                    return;
                }else this.setError( 'tel', '');
                let s = 60;
                this.disabled = true;
                const timer = setInterval( () => {
                    s -- ;
                    this.btnText = `${s}秒后重新获取`;
                    if(s <= 0) {
                        clearInterval(timer);
                        this.btnText = '重新获取验证码';
                        this.disabled = false;
                    }
                }, 1000);
                post_auth_code_password({tel}, (res)=>{
                    let {status, message} = res;
                    if(status !== 2) this.setError('tel', message);
                });

            },
            setError(key, msg){
                this.formErrors[key + 'Error'] = msg;
                // obj.$refs.formRef.validateField(msg);
            }
        },
    }
</script>

<style scoped>
    .tabs-center {
        padding: 20px;
    }

    /* 自定义样式 */
    .custom-tabs :deep(.ant-tabs-tab) {
        padding: 12px 24px;
        font-size: 16px;
    }

    /* 确保在响应式下也能居中 */
    .custom-tabs :deep(.ant-tabs-nav) {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .loginHeader span{
        font-size: 25px;
        font-weight: 700;
    }
    .siteSummary ul{
        list-style: none;
        padding: 0;
    }
    .siteSummary ul li{
        margin-top: 10px;
        list-style: none;
    }
    @media screen and (min-width: 1200px){
        .loginTipsWrapper{
            padding: 20px 30px;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            min-height: 100%;
        }
        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 400px;
            height: 100%;
            border-radius: 5px;
        }
    }
    @media screen and (min-width: 769px) and (max-width: 1200px){

        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 400px;
            height: 100%;
            border-radius: 5px;
        }
    }
    @media screen and (max-width: 768px){

        .loginBoxWrapper{
            background-color: #ffffff;
            padding: 20px;
            width: 100%;
            border-radius: 5px;
        }
    }

</style>

